import React, { useState } from "react";
import { Tab, Nav, Row, Col, Accordion, Container } from "react-bootstrap";
import { GeneralFAQs } from "./general";
import { BuyersFAQs } from "./buyers";
import { MerchantFAQs } from "./merchants";

export const FAQs = () => {
  const tabs = [
    { tab: "General", content: <GeneralFAQs /> },
    { tab: "Buyers", content: <BuyersFAQs /> },
    { tab: "Merchants", content: <MerchantFAQs /> },
  ];

  const [activeTab, setActiveTab] = useState<string>(tabs[0].tab);

  return (
    <div className=" my-4" style={{ minHeight: "600px" }}>
      <Container className="px-3 ">
        <Tab.Container
          activeKey={activeTab}
          onSelect={(k) => k && setActiveTab(k)}
        >
          <Row>
            <Col sm={12}>
              <Nav variant="pills" className="flex-row mb-4">
                {tabs.map(({ tab }) => (
                  <Nav.Item key={tab}>
                    <Nav.Link eventKey={tab}>{tab}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>

            <Col sm={12}>
              <Tab.Content>
                {tabs.map(({ tab, content }) => (
                  <Tab.Pane eventKey={tab} key={tab}>
                    {content}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  );
};
